export default __webpack_public_path__ + "media/images/image-1-7056a36a0d769f1decd1ba3a12d3949a.jpg";